import { IconPlus, IconX } from '@tabler/icons-react'
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { uploadImage } from '../../../api/api.global';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';

const AddAdmin = ({ callback }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => { setFile(null); setShow(false) };
    const handleShow = () => setShow(true);
    const [file, setFile] = useState(null);

    function fileOnChange(event) {
        setFile(event.target.files[0]);
        let file = event.target.files[0];
        document.getElementById('pic-preview').src = URL.createObjectURL(file);
    }

    async function add() {
        if (!file) {
            toast.error("Please select a profile picture");
            return;
        }
        loadingShow();
        let postData = {
            "username": document.getElementById('admin-name')?.value,
            "phone": document.getElementById('admin-mobile')?.value,
            "password": document.getElementById('password')?.value,
            "profilePic": await uploadImage(file, "advy-admin-profile-pic")
        }
        let resp = await postApi(postData, urlApi.addAdmin);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            if (callback) {
                callback()
            }
            handleClose()
        } else {
            toast.error(resp.message)
        }
    }

    return (
        <>
            <button className="inline-flex bg-green-700 !py-1.5 text-white px-3 text-sm items-center gap-1 rounded-md " onClick={handleShow}>
                <IconPlus size={16} /> Admin
            </button>

            <Modal show={show} onHide={handleClose} backdrop="static" >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold ">Add Admin</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className='flex flex-col gap-2'>
                        <div className="flex flex-col gap-1">
                            <label htmlFor="admin-name" className='font-medium'>Name</label>
                            <input type="text" id='admin-name' placeholder="Name" className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label htmlFor="admin-mobile" className='font-medium'>Mobile</label>
                            <input type="tel" placeholder="Mobile" id='admin-mobile' className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' />
                        </div>
                        <div className="flex flex-col gap-1">
                            <label htmlFor="password" className='font-medium'>Password</label>
                            <input type="text" placeholder="Password" id='password' className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' />
                        </div>
                        <label htmlFor="admin-profile-file">Profile Picture</label>
                        <input type="file" name="" id="admin-profile-file" onChange={(e) => fileOnChange(e)} className='w-full p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' accept="image/png, image/gif, image/jpeg" />
                        <img src="" alt="" id='pic-preview' className='max-h-[200px] max-w-full object-contain rounded-md' />
                    </div>
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='px-4 py-1 bg-[var(--secondary)] text-white text-sm font-semibold rounded-lg' onClick={handleClose}>Cancel</button>
                        <button className='px-4 py-1 bg-[var(--secondary-gradient-1)] text-white text-sm font-semibold rounded-lg' onClick={() => add()}>Add</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddAdmin